var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "radio-control"
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.item.controlValue,
      border: true
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: _vm.$t("选项值")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input", {
          model: {
            value: scope.row.name,
            callback: function ($$v) {
              _vm.$set(scope.row, "name", $$v);
            },
            expression: "scope.row.name"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "isWrite",
      label: _vm.$t("允许填空")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-checkbox", {
          model: {
            value: scope.row.isWrite,
            callback: function ($$v) {
              _vm.$set(scope.row, "isWrite", $$v);
            },
            expression: "scope.row.isWrite"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: _vm.$t("操作")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button-group", [scope.$index === 0 ? _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.addOptionDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _vm._e(), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: scope.$index === 0
          },
          on: {
            click: function ($event) {
              return _vm.moveUpDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("上移")))]), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: scope.$index === _vm.item.controlValue.length - 1
          },
          on: {
            click: function ($event) {
              return _vm.moveDownDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下移")))]), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: _vm.item.controlValue.length === 1
          },
          on: {
            click: function ($event) {
              return _vm.deleteOptionDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)];
      }
    }])
  })], 1), _vm.item.controlValue.length === 0 || _vm.item.controlValue[_vm.item.controlValue.length - 1].selected ? _c("el-row", {
    staticClass: "add-option-row"
  }, [_c("el-button", {
    attrs: {
      icon: "el-icon-plus",
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.addOptionDA(_vm.item.controlValue.length);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("添加选项")))])], 1) : _vm._e()], 1), _c("div", {
    staticClass: "number_value",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排列方式")
    }
  }, [_c("a-select", {
    staticClass: "layout-select",
    staticStyle: {
      width: "320px"
    },
    attrs: {
      placeholder: _vm.$t("请选择排列方式")
    },
    model: {
      value: _vm.item.sortWay.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.sortWay, "type", $$v);
      },
      expression: "item.sortWay.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "VERTICAL"
    }
  }, [_vm._v(_vm._s(_vm.$t("竖向排列")))]), _c("a-select-option", {
    attrs: {
      value: "TRANSVERSE"
    }
  }, [_vm._v(_vm._s(_vm.$t("横向排列")))])], 1)], 1)], 1), _vm.item.sortWay.type === "TRANSVERSE" ? _c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("每行列数：")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "320px"
    },
    attrs: {
      placeholder: _vm.$t("请选择每行列数")
    },
    model: {
      value: _vm.item.sortWay.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.sortWay, "value", $$v);
      },
      expression: "item.sortWay.value"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行2列")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行3列")))]), _c("a-select-option", {
    attrs: {
      value: "4"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行4列")))]), _c("a-select-option", {
    attrs: {
      value: "5"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行5列")))]), _c("a-select-option", {
    attrs: {
      value: "6"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行6列")))]), _c("a-select-option", {
    attrs: {
      value: "7"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行7列")))]), _c("a-select-option", {
    attrs: {
      value: "8"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行8列")))]), _c("a-select-option", {
    attrs: {
      value: "9"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行9列")))]), _c("a-select-option", {
    attrs: {
      value: "10"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行10列")))])], 1)], 1)], 1) : _vm._e()]), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "number_value"
  }, [_c("div", {
    staticClass: "flex_1",
    staticStyle: {
      "margin-left": "34px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "flex_1"
  }, [_c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宏样式"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.macroStyle,
      callback: function ($$v) {
        _vm.$set(_vm.item, "macroStyle", $$v);
      },
      expression: "item.macroStyle"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "ALL"
    }
  }, [_vm._v(_vm._s(_vm.$t("展示全部选项")))]), _c("a-radio", {
    attrs: {
      value: "Selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("仅展示选中选项")))])], 1)], 1)], 1)])])]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        return _vm.formeClase(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };